import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "csv-site",
  components: {
    AppHeader
  },
  created() {
    this.getTodayDate();
    this.getCompany();
  },
  data() {
    return {
      companies: "",
      siteLists: "",
      getCompanisEnd: false,
      getSitesEnd: false,
      selectedCompany: localStorage.company_id,
      keyword: "",
      siteId: "",
      siteNumber: "",
      siteName: "",
      canChoiceStartYears: [],
      canChoiceEndYears: [],
      startDayCount: "",
      endDayCount: "",
      startYear: "",
      startMonth: "",
      startDay: "",
      endYear: "",
      endMonth: "",
      endDay: "",
      allSelect: true
    };
  },
  computed: {
    isDayOk() {
      if (
        this.startYear &&
        this.startMonth &&
        this.startDay &&
        this.endYear &&
        this.endMonth &&
        this.endDay
      ) {
        if (this.startYear < this.endYear) {
          return true;
        } else if (
          this.startYear == this.endYear &&
          this.startMonth < this.endMonth
        ) {
          return true;
        } else if (
          this.startYear == this.endYear &&
          this.startMonth == this.endMonth &&
          this.startDay <= this.endDay
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  },
  methods: {
    getTodayDate() {
      let today = new Date();
      this.currentYear = today.getFullYear();
      for (let i = 0; i < 5; i++) {
        this.canChoiceStartYears.push(this.currentYear - i);
        this.canChoiceEndYears.push(this.currentYear - i);
      }
      let calcMonth = today.getMonth() + 1;
      let calcDay = today.getDate();
      this.startDayCount = new Date(calcMonth, calcDay, 0).getDate();
      this.endDayCount = new Date(calcMonth, calcDay, 0).getDate();
    },
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getSites() {
      this.getSitesEnd = false;
      let data = {
        company_id: this.selectedCompany,
        search_word: this.keyword
      };
      let res = await this.$store
        .dispatch("GET_SITE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.siteLists = res.sites;
      this.getSitesEnd = true;
    },
    siteDecision(site) {
      this.siteId = site.id;
      this.siteNumber = site.site_number;
      this.siteName = site.name;
      this.$bvModal.hide("modal-work");
    },
    changeCompany() {
      this.getSites();
      this.siteId = "";
      this.siteNumber = "";
      this.siteName = "";
    },
    getStartDayCount() {
      this.startDay = "";
      this.startDayCount = new Date(
        this.startYear,
        this.startMonth,
        0
      ).getDate();
    },
    getEndDayCount() {
      this.endDay = "";
      this.endDayCount = new Date(this.endYear, this.endMonth, 0).getDate();
    },
    async csvDownload() {
      let data = {
        company_id: this.selectedCompany,
        all_select: this.allSelect,
        site_id: this.siteId,
        start_date: dayjs(
          `${this.startYear}-${this.startMonth}-${this.startDay}`
        ).format("YYYY-MM-DD"),
        end_date: dayjs(
          `${this.endYear}-${this.endMonth}-${this.endDay}`
        ).format("YYYY-MM-DD")
      };
      let res = await this.$store
        .dispatch("GET_SITE_CSV", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.downloadCsv(res.contents);
    },
    downloadCsv: function(data) {
      let wkFileName =
        "現場毎作業内容一覧" +
        dayjs(`${this.startYear}-${this.startMonth}-${this.startDay}`).format(
          "YYYYMMDD"
        ) +
        "-" +
        dayjs(`${this.endYear}-${this.endMonth}-${this.endDay}`).format(
          "YYYYMMDD"
        ) +
        ".csv";
      const csvFileName = wkFileName;
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      let mimeType = "text/csv";
      let csv =
        "工事番号,現場名,日付,社員名,車両番号,車両名,高速利用,作業メモ,開始時刻,終了時刻,現場滞在時間,時給,出勤時刻登録時刻,退勤時刻登録時刻\n";
      data.forEach(obj => {
        if (obj.site_number) {
          csv += this.enquoteForCSV(obj.site_number) + ",";
        } else {
          csv += ",";
        }
        if (obj.site_name) {
          csv += this.enquoteForCSV(obj.site_name) + ",";
        } else {
          csv += ",";
        }
        if (obj.attendance_date) {
          csv += this.enquoteForCSV(obj.attendance_date) + ",";
        } else {
          csv += ",";
        }
        if (obj.user_name) {
          csv += this.enquoteForCSV(obj.user_name) + ",";
        } else {
          csv += ",";
        }
        if (obj.car_number) {
          csv += this.enquoteForCSV(obj.car_number) + ",";
        } else {
          csv += ",";
        }
        if (obj.car_name) {
          csv += this.enquoteForCSV(obj.car_name) + ",";
        } else {
          csv += ",";
        }
        if (obj.is_highway_use == 1) {
          csv += "あり,";
        } else {
          csv += "なし,";
        }
        if (obj.content) {
          csv += this.enquoteForCSV(obj.content) + ",";
        } else {
          csv += ",";
        }
        if (obj.start_hhmm) {
          csv += this.enquoteForCSV(obj.start_hhmm) + ",";
        } else {
          csv += ",";
        }
        if (obj.end_hhmm) {
          csv += this.enquoteForCSV(obj.end_hhmm) + ",";
        } else {
          csv += ",";
        }
        if (obj.roudou_jikan) {
          csv += this.enquoteForCSV(obj.roudou_jikan) + ",";
        } else {
          csv += ",";
        }
        if (obj.hourly_wage) {
          csv += this.enquoteForCSV(obj.hourly_wage) + ",";
        } else {
          csv += ",";
        }
        if (obj.clocked_on_at) {
          csv += this.enquoteForCSV(obj.clocked_on_at) + ",";
        } else {
          csv += ",";
        }
        if (obj.clocked_off_at) {
          csv += this.enquoteForCSV(obj.clocked_off_at);
        } else {
          csv += "";
        }
        csv += "\n";
      });
      const blob = new Blob([bom, csv], { type: mimeType });
      let hiddenElement = document.createElement("a");
      hiddenElement.download = csvFileName;
      hiddenElement.target = "_blank";
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName);
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob);
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
        document.body.removeChild(hiddenElement);
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(
          blob
        );
        hiddenElement.click();
      }
    },
    enquoteForCSV: function(val) {
      if (!val) return val;
      if (/[",\r\n]/.test(val)) {
        //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val;
    }
  }
};
